import { makeStyles } from "tss-react/mui";

interface StyleProps {
  isScrollable?: boolean;
}

export const useStyles = makeStyles<StyleProps>()(
  (theme, { isScrollable = false }) => ({
    container: {
      display: "flex",
      flexDirection: "column",
      position: isScrollable ? "relative" : "fixed",
      bottom: isScrollable ? "auto" : 0,
      left: isScrollable ? "auto" : 0,
      right: isScrollable ? "auto" : 0,
      backgroundColor: "white",
      borderTop: "1px solid #e5e5e7",
      boxShadow: isScrollable ? "none" : "0 -2px 10px rgba(0, 0, 0, 0.05)",
      zIndex: isScrollable ? "auto" : 100,
    },
    userInputDisplay: {
      display: "flex",
      padding: theme.spacing(6, 5, 3),
      borderBottom: "1px solid #e5e5e7",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
    },
    userInputText: {
      flex: 1,
      fontSize: "0.875rem",
      color: "#0A1A2F",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginRight: theme.spacing(3),
      marginTop: theme.spacing(2.5),
    },
    createButton: {
      padding: theme.spacing(4, 11),
      backgroundColor: theme.palette.secondary.main,
      color: "white",
      border: "none",
      borderRadius: "1.25rem",
      fontSize: "0.875rem",
      fontWeight: 500,
      cursor: "pointer",
      transition: "background-color 0.2s",

      "&:disabled": {
        backgroundColor: "#d2d2d7",
        cursor: "not-allowed",
        opacity: 0.7,
      },
    },
  })
);
